import { ChangeDetectorRef, Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { QuarterlyTaxReceiptModel } from "../quarterly-tax-receipt.model";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { QuarterlyTaxReceiptService } from "../quarterly-tax-receipt.service";
import { CoreComponent } from "../../../../core/header/core.component";
import { AddFileService } from "../../../../shared/components/add-file/add-file.service";
import { HttpClient } from "@angular/common/http";
import { consts } from "../../../../consts";
import { TaxesTabService } from "../../taxes-tabs.service";

@Component({
    selector: 'convfact-quarterly-tax-receipt-edit',
    templateUrl: './quarterly-tax-receipt-edit.component.html',
    styleUrls: ['./quarterly-tax-receipt-edit.component.css'],
    standalone: false
})

export class QuarterlyTaxReceiptFormComponent implements OnInit {
  @Input() model: QuarterlyTaxReceiptModel;
  @Output() onSave = new EventEmitter<any>();

  @Input() errors: object;

  ready: boolean = false;

  position = 'above';

  imageTempUrl: any = '';
  pdfTempUrl: any;
  pdfTemp: any;

  result: number;


  originEntity: string = consts.QUARTER_TAX_RECEIPT_ENTITY;
  filePath: string = consts.QUARTER_TAX_RECEIPT_FILE_PATH;

  readOnly: boolean = false;
  hasDuplicateExpense: boolean;

  readyLoadedFiles: boolean = null;


  constructor(
    public snackBar: MatSnackBar,
    private quarterTaxReceiptService: QuarterlyTaxReceiptService,
    private core: CoreComponent,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private addFileService: AddFileService,
    public http: HttpClient,
    private router: Router,
  ) { }


  ngOnInit() {
    this.ready = true;

    if (this.model.pdf) {
      this.readyLoadedFiles = false;
      this.addFileService.getImageFromFilesPDF(this.model.fileUid, this.originEntity).then(result => {
        this.changeFile(result);
        this.readyLoadedFiles = true;
      });

    } if (this.model.image) {
      this.readyLoadedFiles = false;
      this.addFileService.getImageFromFiles(this.model.fileUid, this.originEntity).then(response => {
        this.createImageFromBlob(response);
        this.readyLoadedFiles = true;
      });
    }
  }


  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    if (image) {
      reader.readAsDataURL(image);
      reader.onloadend = () => {
        this.imageTempUrl = reader.result;
        this.ref.detectChanges();
      }
      this.ref.detectChanges();
    }
  }

  SetFileParameters(event): void {

    this.model.image = event.Image;
    this.model.pdf = event.PDF;
    this.model.fileUid = event.FileUid;

    if (event.File && event.Image) {
      this.createImageFromBlob(event.File);
    }
    if (event.PDF) {
      this.changeFile(event.File);
    }
  }

  changeFile(data: any) {
    this.imageTempUrl = data;
    this.ref.detectChanges();
  }

  save() {
    let noError = true;

    if (this.model.amount == null || this.model.amount == undefined) {
      noError = false;
      this.displayInfo("Debe especificar importe valido");
    }

    if (this.model.period == null || this.model.period == "" || this.model.period == undefined) {
      noError = false;
      this.displayInfo("Debe especificar periodo valido");
    }

    if (this.model.taxYear == null || this.model.taxYear == undefined) {
      noError = false;
      this.displayInfo("Debe especificar un año valido");
    }

    if (this.model.taxFormModel == null || this.model.taxFormModel == undefined) {
      noError = false;
      this.displayInfo("Debe especificar un modelo válido");
    }

    if (this.model.receiptNumber == null || this.model.receiptNumber == "" || this.model.receiptNumber == undefined) {
      noError = false;
      this.displayInfo("Debe especificar número de justificante valido");
    }

    if (noError) {
      this.quarterTaxReceiptService.saveRequestUpdateValue(true);
      this.onSave.emit(this.model);
    }
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  cancel(): void {
    this.router.navigate(['/taxes/quarter-tax-receipts']);
  }

}
